import React, { useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import Sidebar from './Sidebar';

const Layout = ({ children, user = null }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen w-full bg-gray-100">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        user={user} 
      />

      {/* Main Content */}
      <div className="flex-1 container lg:ml-0 bg-white overflow-y-scroll w-full">
        {/* Mobile Header */}
        <div className="lg:hidden shadow-sm border-b border-gray-200 px-4 py-3">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setSidebarOpen(true)}
              className="text-gray-600 hover:text-gray-900"
            >
              <FiMenu className="h-6 w-6" />
            </button>
            <div className="w-6"></div> {/* Spacer for centering */}
          </div>
        </div>

        {/* Page Content */}
        <div className="flex flex-col h-full bg-white">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout; 